import { useMutation } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

interface MatterIssuesResponse {
  caseName?: string;
  caseIssues?: string;
  caseType?: string;
  caseEntities?: string;
}

export const useGenerateMatterIssues = ({ matterId }: { matterId: string }) => {
  const { getFetchConfig } = useGetFetchConfig();

  return useMutation(async ({ file }: { file: File }): Promise<MatterIssuesResponse> => {
    const formData = new FormData();
    formData.append('file', file);

    const fetchConfig = getFetchConfig({
      method: FetchMethod.POST,
      data: formData,
      isFormData: true,
    });

    const response = await fetch(`${APIBaseChronos}/api/matters/${matterId}/generate-details`, fetchConfig);

    if (!response.ok) {
      throw new Error('Failed to generate case details');
    }

    return response.json();
  });
};
